module.exports = __webpack_public_path__ + "img/wallet_02_nft_2.1b4cd101.png";